import { useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function AnnouncementBanner({ isAuthenticated }: { isAuthenticated?: boolean }) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem('banner_dismissed') === 'true';
  });

  // Only show to non-logged-in users
  if (isAuthenticated || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('banner_dismissed', 'true');
  };

  return (
    <div className="bg-[#F4F7EE] py-2 relative border-b border-accent-text/20">
      <div className="max-w-page mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-center gap-2 text-center">
        <Sparkles className="h-3.5 w-3.5 flex-shrink-0 hidden sm:block text-accent-text" />
        <p className="text-xs sm:text-sm font-medium text-[#2F4F3E]">
          {t('banner.earlyAdopter', { defaultValue: 'Launch offer - Professional memberships are free for a limited time!' })}
        </p>
        <button
          onClick={handleDismiss}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-accent-text/10 rounded-full transition-colors text-[#2F4F3E]"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
